import { SET_TOKEN, SIGNIN_SUCCESS, UPDATE_TOKEN } from "../types/type"

export const login = (userDetail) => {
    return ({
        type: SIGNIN_SUCCESS,
        payload: userDetail
    })
}

export const setToken = (tokens) => {
    return ({
        type: SET_TOKEN,
        payload: tokens
    })
}

export const updateToken = (newToken) => {
    return ({
        type: UPDATE_TOKEN,
        payload: newToken
    })
}